import { adsDarkPurple } from "../utils/ADSColours";

const ConstructionType = [
  {
    id: 1,
    gpText: "Street Reinstatement",
    colour: adsDarkPurple,
  },
  {
    id: 2,
    gpText: "Special Surface",
    colour: adsDarkPurple,
  },
  {
    id: 3,
    gpText: "Special Construction Needs",
    colour: adsDarkPurple,
  },
];

export default ConstructionType;
